import { render, staticRenderFns } from "./ToolbarPreventivi.vue?vue&type=template&id=3db1f158&scoped=true&"
import script from "./ToolbarPreventivi.vue?vue&type=script&lang=js&"
export * from "./ToolbarPreventivi.vue?vue&type=script&lang=js&"
import style0 from "../../assets/styles/preventivo.css?vue&type=style&index=0&id=3db1f158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db1f158",
  null
  
)

export default component.exports